import { Layout, Menu } from 'antd'
import { Component } from 'react'
import * as React from 'react'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { ThunkDispatch } from "redux-thunk"
import { AnyAction } from "redux"
import { RootState } from '../../core/reducers'
import { actionGetMenuAndOrg, actionGetSilizhuMenuAndOrg } from '../../core/actions/user';
import { LoginDevice } from '../../javascripts/public'

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;

interface StateProps {
    collapsed: boolean
    routeKey: string
    orgInfo: any
    menuData: any[]
    loginDevice: LoginDevice | string
}

interface DispatchProps {
    getMenu(): void
    getMenuSilizhu(): void
}

type PropsType = RouteComponentProps & StateProps;

class SiderNav extends Component<PropsType & DispatchProps> {
   
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        console.log('didMount');
        if(this.props.loginDevice === LoginDevice.SCANNER) {
            this.props.getMenu();
        }
        else {
            this.props.getMenuSilizhu();
        }
    }
    
    state = {
        SubMenu: null,
        openKeys: ['']
    }

    refreshKey = () => {
        let menuData = this.props.menuData || [];
        this.getSubMenu(menuData);
        const { history } = this.props;
        let pathname = history.location.pathname;
        for(let i in menuData) {
            let item = menuData[i].children;
            if(item) {
                for(let index in item) {
                    if(pathname.search(item[index].path) === 0 && !item[index].children) {
                        return {
                            selectedKeys: [`${item[index].key}`],
                            openKeys: [`${menuData[i].key}`]
                        }
                    }
                    else if(item[index].children) {
                        pathname = pathname.replace(item[index].path,'')
                        let data = item[index].children;
                        for(let j in data) {
                            if(pathname.search(data[j].path) === 0 ) {
                                return {
                                    selectedKeys: [`${data[j].key}`],
                                    openKeys: [`${menuData[i].key}`]
                                }
                            }
                        }
                    }
                    else if(pathname.search('/setting') === 0){
                        return {
                            selectedKeys: ['setting'],
                            openKeys: ['userManage']
                        }
                    }
                }
            }
            else {
                let detailIndex = pathname.indexOf("detail");
                if(menuData[i].path.search(pathname) === 0 || (
                    detailIndex !== -1 && menuData[i].path.search(pathname.substring(0, detailIndex - 1)) === 0
                )) {
                    return {
                        selectedKeys: [`${menuData[i].key}`],
                        openKeys: [`${menuData[i].key}`]
                    }
                }
            }
        }
        return null;
    }

    getSubMenuChildren = (data) => {
        return (
             <SubMenu
                 title={
                     <span>{data.name}</span>
                 }
                 key={data.key}
                 >
                 {
                     data.children.map((item) => {
                         return (
                             <MenuItem key={item.key}>
                                 <Link to={data.path + item.path}>{item.name}</Link>
                             </MenuItem>
                         )
                     })
                 }
             </SubMenu>
         )
             
     }

     getSubMenu = (menuData) => {
        this.state['SubMenu'] = menuData.map((item) => {
            if(item.children) {
                return (
                    <SubMenu
                        title={<span>{item.name}</span>}
                        icon={<span><img src={item.image} /></span>}
                        key={item.key}
                        >
                        {
                            item.children.map((data) => {
                                if(data.children) {
                                    let subMenuChildren = this.getSubMenuChildren(data);
                                    return subMenuChildren;
                                }
                                else {
                                    return (
                                        <MenuItem key={data.key}>
                                            <Link to={data.path}>{data.name}</Link>
                                        </MenuItem>
                                    )
                                }
                            })
                        }
                    </SubMenu>
                )
            }
            else {
                return (
                    <MenuItem 
                        key={item.key} 
                        icon={
                            <span>
                                <img src={item.image} className="menu-icon" />
                            </span>
                        }
                        >
                        <Link to={item.path}>{item.name}</Link>
                    </MenuItem>
                )
            }
        })
    }

    onOpenChange = (openKeys) => {
       this.setState({ openKeys });
    }

    render() {

        let refreshData = this.refreshKey();
        let orgInfo = this.props.orgInfo || {};
        console.log("openKeys", refreshData ? refreshData.selectedKeys: "")
        
        return (
            <Sider
                trigger={null}
                collapsible
                width={256}
                collapsed={this.props.collapsed}
                >
                <div className="logo" >
                   {
                        orgInfo.logo ? 
                        <img src={orgInfo.logo} />
                        :
                        <p>{orgInfo.name}</p>
                   }
                </div>
                <Menu 
                    theme="dark" 
                    mode="inline" 
                    defaultSelectedKeys={refreshData ? refreshData.selectedKeys: ['reportList']} 
                    defaultOpenKeys={refreshData ? refreshData.openKeys : ['reportManage']}
                    openKeys={this.state['openKeys'] ? this.state['openKeys'] : (refreshData ? refreshData.openKeys : [''])}
                    selectedKeys={refreshData ?  refreshData.selectedKeys : ['reportList']}
                    onOpenChange={this.onOpenChange}
                    >
                    {this.state['SubMenu']}
                </Menu>
            </Sider>
        );
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        collapsed: state.style.collapsed,
        menuData: state.user.menuData,
        orgInfo: state.user.orgInfo,
        routeKey: state.user.routeKey,
        loginDevice: state.user.loginDevice,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getMenu: () => {
            dispatch(actionGetMenuAndOrg())
        },
        getMenuSilizhu: () => {
            dispatch(actionGetSilizhuMenuAndOrg())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiderNav))